import about from '../../../../Images/About.jpg';
import about01 from '../../../../Images/background/01.jpg';
import about02 from '../../../../Images/background/02.jpg';
import ai from '../../../../Images/icons/ai.png';
import ternative from '../../../../Images/icons/alternative.png';
import Breadcrumb from '../../../Breadcrumb/Breadcrumb';

import './AboutUs.css';

const AboutUs = () => {
  return (
    <div>
      <Breadcrumb
        title='About Us
'
        subTitle='About Us
'
        img={about}
        slgs='/about'
      ></Breadcrumb>
      <section className='bg-white pb-[60px] pt-[60px]'>
        <div className='container px-6 py-10 mx-auto'>
          <div className='grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-2'>
            <div className='about-left'>
              <div className='about-img'>
                <div className='grid grid-cols-2 gap-0 md:grid-cols-2 lg:grid-cols-2'>
                  <div>
                    <img
                      className='img-1 w-full h-auto'
                      src={about01}
                      alt='about-banner'
                    />
                  </div>
                  <div>
                    <img
                      className='img-2 w-full h-auto'
                      src={about02}
                      alt='about-banner'
                    />
                  </div>
                </div>
              </div>
              <div className='about-experience'>
                <h5 className='text-[37px] font-bold text-white'>10+</h5>
                <p className='text-white font-medium text-base'>
                  Years Of Experience
                </p>
              </div>
            </div>
            <div className=''>
              <p className='text-lg title-gradient uppercase'>About us</p>

              <h1 className='block mt-4 text-2xl font-semibold text-[#124265]'>
                We have been thriving in the tech area for 10 years.
              </h1>

              <p className='mt-3 text-base  dark:text-gray-400 md:text-base mb-4'>
                With a solid foundation built over ten successful years, M.
                Solaiman Technical Training Center stands as a testament to
                consistent quality and career transformation. Our decade-long
                journey has been defined by adapting to industry shifts,
                refining our specialized curriculum, and graduating hundreds of
                competent technicians. This extensive experience ensures that
                our programs are not just current, but are also deeply rooted in
                proven, real-world methodologies, providing every student with a
                reliable advantage in the competitive job market.
              </p>
              <hr />
              <div className='mt-5 grid grid-cols-1 gap-8 md:mt-5 md:grid-cols-2 md:gap-12 lg:grid-cols-2'>
                <div className='flex items-start gap-4'>
                  <span className='shrink-0 rounded-lg bg-primary p-3'>
                    <img
                      className='w-7 h-7'
                      loading='lazy'
                      src={ternative}
                      alt='ternative'
                    />
                  </span>

                  <div>
                    <h2 className='text-lg font-bold text-[#124265]'>
                      Our Vision
                    </h2>

                    <p className='mt-1 text-sm text-gray-400'>
                      To be the leading center for innovative, globally
                      recognized technical training.
                    </p>
                  </div>
                </div>

                <div className='flex items-start gap-4'>
                  <span className='shrink-0 rounded-lg bg-primary p-3'>
                    <img className='w-7 h-7' src={ai} alt='ai' loading='lazy' />
                  </span>

                  <div>
                    <h2 className='text-lg font-bold text-[#124265]'>
                      Our Mission
                    </h2>

                    <p className='mt-1 text-sm text-gray-400'>
                      To empower students with practical skills for immediate
                      job market success.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
